module.exports = __webpack_public_path__ + "img/idx_tit3.1620c948.png";